/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { Component, FormEvent } from 'react';
import Content from './verify.content';
import { buildErrorMsgFromForm, getContent, stopProp } from '../../utils';
import { TargetChange } from '../../_shared/interfaces/target';
import { Button } from '../../_shared/button';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import Logo from '../../_shared/logo';
import SharedStyles from '../../_shared/styles';
import styles from '../authentication.styles';
import { message } from 'antd';
import Link from '../../_shared/link';
import { resendCode } from '../../_shared/services/authentication.service';
import { get } from 'lodash';
import {
  generatePinAndSendMsgToUser,
  validateCode,
} from '../../_shared/services/manage-users.service';
import { WithForm } from '../../_shared/form';

interface IProps extends RouteComponentProps {
  verify: (email: string, code: string) => Promise<{ error?: string }>;
  signIn: (
    email: string,
    password: string,
    checkRole?: boolean,
    setToActive?: boolean
  ) => Promise<{}>;
  destination?: string;
  form?: any;
}

class VerifyComponent extends Component<IProps> {
  state = {
    code: '',
    loading: false,
    is2fa: undefined,
    email: '',
    password: '',
    method: undefined,
  };
  componentDidMount = () => {
    const { history } = this.props;
    const state = get(history, 'location.state', {});
    this.setState({
      ...this.state,
      ...(state as any),
    });
  };
  changeVal = (e: TargetChange) => {
    this.setState({ code: e.target.value });
  };
  submit = async (e: MouseEvent | FormEvent) => {
    stopProp(e);
    if (this.state.loading) {
      return;
    }

    this.state.loading = true;
    this.setState(this.state);
    this.props.form.validateFieldsAndScroll(async (err: any, values: any) => {
      if (err) {
        const error = buildErrorMsgFromForm(err);
        message.error(error);
        return this.setState({ loading: false });
      }
      const { code } = values;
      try {
        const { is2fa, email, password } = this.state;

        let resp;
        if (is2fa) {
          const isValid = await validateCode(email, code);
          if (!isValid) {
            throw new Error('Code does not match');
          }
        } else {
          resp = await this.props.verify(email, code);
        }
        await this.props.signIn(email, password, false, true);

        const error = get(resp, 'error');
        if (error) {
          message.error(error);
          this.setState({ loading: false });
        } else {
          this.props.history.push(get(this, 'props.location.state.destination', '/dashboard'));
        }
      } catch (err) {
        message.error(err.message);
        this.setState({
          loading: false,
        });
      }
    });
  };
  resendCode = async () => {
    try {
      const { email, is2fa } = this.state;
      if (is2fa) {
        const { method } = await generatePinAndSendMsgToUser(email);
        this.setState({
          is2fa: true,
          method,
        });
      } else {
        await resendCode(email);
      }
      message.success(
        `New verification code sent to ${
          this.state.method === 'email' ? 'email' : 'sms'
        }`
      );
    } catch (err) {
      message.error(`Error: ${err.message}`);
    }
  };
  render() {
    const { loading } = this.state;
    // AER-1667 (R1): the Verify button stays enabled except while verifying
    // (loading); it is no longer disabled until a code has been entered.
    const { Form } = this.props.form;
    const content = getContent(Content);
    return (
      <div className="Verify" css={css(styles.container)}>
        <div css={css(SharedStyles.logoWrap)}>
          <Logo />
        </div>

        <p css={css(styles.title)}>
          {(this.state.method &&
            this.state.method === 'sms' &&
            content.title.sms) ||
            content.title.email}
        </p>

        <div css={css(styles.inputContainer)}>
          <Form
            forceUpdate={this}
            onSubmit={this.submit}
            items={[{ title: 'Verification Code', var: 'code' }]}
          >
            <div css={css(styles.buttonContainer, `margin-top: 10px;`)}>
              <Link css={css('margin-bottom: 10px;')} onClick={this.resendCode}>
                {'Resend Verification Code'}
              </Link>
              <Button
                loading={loading}
                title={content.button}
                onClick={this.submit}
                disabled={loading}
              />
            </div>
          </Form>
        </div>
      </div>
    );
  }
}

export const Verify = WithForm(withRouter(VerifyComponent));
